import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { utmZoneFor } from '../../lib/coordinates';
import { DEMO_ANOMALIES } from '../../lib/mapViewHelpers';

export default function MapStatusBar({ tool, coordSys, viewport, layers, importedLayers, resultLayers, fitToData, cursor, mouseCoord, demoEnabled = true }) {
  const { C } = useTheme();
  return (
    <div style={{ height: 24, padding: '0 12px', background: C.bg1, borderTop: `1px solid ${C.border}`, display: 'flex', gap: 14, alignItems: 'center', fontSize: 11, color: C.text2, overflow: 'hidden', whiteSpace: 'nowrap', flexShrink: 0 }}>
      {/* Live cursor coordinates — click to copy */}
      <span
        className="coords"
        title="Click to copy coordinates"
        onClick={() => {
          if (mouseCoord) navigator.clipboard?.writeText(`${mouseCoord.lat.toFixed(6)}, ${mouseCoord.lon.toFixed(6)}`);
        }}
        style={{ color: C.text0, cursor: mouseCoord ? 'copy' : 'default', minWidth: 172 }}>
        📍 {mouseCoord ? `${mouseCoord.lat.toFixed(4)}, ${mouseCoord.lon.toFixed(4)}` : '—'}
      </span>
      <span style={{ color: C.bg4 }}>|</span>
      <span style={{ color: C.accent }}>{coordSys === 'UTM_AUTO' && mouseCoord ? utmZoneFor(mouseCoord.lon, mouseCoord.lat).code : coordSys === 'UTM_AUTO' ? 'UTM (auto)' : coordSys}</span>
      <span style={{ color: C.bg4 }}>|</span>
      {/* Map scale from zoom + latitude */}
      {viewport?.zoom != null && (
        <span className="coords" title="Approximate map scale">
          1:{Math.round((156543.03392 * Math.cos(((viewport.latitude || 0) * Math.PI) / 180)) / Math.pow(2, viewport.zoom) * 3779.5275).toLocaleString()}
        </span>
      )}
      <span style={{ color: C.bg4 }}>|</span>
      <span>{layers.filter(l => l.visible).length + importedLayers.filter(l => l.visible).length + resultLayers.filter(r => r.visible).length} layers</span>
      {demoEnabled && <span style={{ color: C.red }}>{DEMO_ANOMALIES.length} anomalies</span>}
      <span style={{ marginLeft: 'auto', color: C.warnText }}>Tool: {tool}</span>
      {viewport && (
        <span className="coords" title="Click to fit all data" onClick={fitToData} style={{ cursor: 'pointer', color: C.text1 }}>
          Z{viewport.zoom?.toFixed(1)} ⤢
        </span>
      )}
    </div>
  );
}
